import classNames from 'classnames'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'

import * as styles from './Pagination.module.scss'
import { usePagination, DOTS } from '../../helpers/hooks/usePagination'
import { SvgChevron } from '../ui/svg-icons'


function Pagination({
  className,
  prevPage,
  nextPage,
  pageCount,
  currentLocation,
  currentPage,
  siblingCount = 1,
  path,
  hasNextPage,
  hasPreviousPage,
  anchorToID,
}) {
  const paginationRange = usePagination({
    currentPage,
    pageCount,
    siblingCount,
  })

  if (currentPage === 0 || paginationRange.length < 2) {
    return null
  }

  return (
    <div className={classNames(styles.pagination, className)}>
      <ul className={styles.paginationDigitList}>
        <li>
          {hasPreviousPage ? (
            <Link
              to={prevPage}
              rel="prev"
              aria-label="Previous page"
              className={styles.arrowButton}
            >
              <SvgChevron width={7} height={13} isReversed />
            </Link>
          ) : (
            <SvgChevron
              className={styles.disabled}
              width={7}
              height={13}
              isReversed
            />
          )}
        </li>
        {paginationRange.map((pageNumber, index) => {
          let isActive

          if (
            (currentLocation === path && pageNumber === 1) ||
            currentLocation === `${path}${pageNumber}/`
          ) {
            isActive = true
          }

          if (pageNumber === DOTS) {
            return (
              <li key={index} className={styles.digit}>
                {DOTS}
              </li>
            )
          }

          return (
            <li key={index}>
              <Link
                to={`${path}${
                  index === 0 ? anchorToID : `${pageNumber}/${anchorToID}`
                }`}
                className={classNames(
                  styles.digit,
                  isActive && styles.activeLink
                )}
              >
                {pageNumber}
              </Link>
            </li>
          )
        })}
        <li>
          {hasNextPage ? (
            <Link
              to={nextPage}
              rel="next"
              aria-label="Next page"
              className={classNames(
                styles.arrowButton,
                !hasNextPage && styles.disabled
              )}
            >
              <SvgChevron width={7} height={13} />
            </Link>
          ) : (
            <SvgChevron className={styles.disabled} width={7} height={13} />
          )}
        </li>
      </ul>
    </div>
  )
}

Pagination.propTypes = {
  anchorToID: PropTypes.string.isRequired,
  currentPage: PropTypes.number.isRequired,
  currentLocation: PropTypes.string.isRequired,
  path: PropTypes.string,
  prevPage: PropTypes.string,
  nextPage: PropTypes.string,
  pageCount: PropTypes.number,
  siblingCount: PropTypes.number,
  hasNextPage: PropTypes.bool,
  hasPreviousPage: PropTypes.bool,
  className: PropTypes.string,
}

export default Pagination
